import { useEffect } from "react";
import { clearAppBadge, type BadgeNavigator } from "./push-payload";

/** OWN-162: the push handler sets the app-icon badge (unread total); once the user is back in the
 * app (mount, window focus, tab becomes visible) they see the real counts, so the badge is cleared. */
export function useClearAppBadge(): void {
  useEffect(() => {
    const nav = typeof navigator === "undefined" ? undefined : (navigator as BadgeNavigator);
    const clearIfActive = () => {
      if (document.visibilityState === "visible") void clearAppBadge(nav);
    };
    clearIfActive();
    window.addEventListener("focus", clearIfActive);
    document.addEventListener("visibilitychange", clearIfActive);
    return () => {
      window.removeEventListener("focus", clearIfActive);
      document.removeEventListener("visibilitychange", clearIfActive);
    };
  }, []);
}
